<div class="auth-page flex flex-column">
  <div class="flex justify-content-center p-4 md:p-5">
    <img
      class="logo-image"
      src="/images/header_logo.svg"
      width="96"
      height="44"
      alt="Full Scale Solutions"
    />
  </div>

  <div class="flex-1 flex align-items-start md:align-items-center justify-content-center px-3 py-4">
    <div class="flex flex-column align-items-center form-width">
      @if (!isSent()) {
        <div class="icon-badge">
          <app-lock-03 stroke="#414651" width="1.25rem" height="1.25rem"></app-lock-03>
        </div>
        <div class="mt-3 display-sm-semibold text-gray-900 text-center">Zaboravili ste lozinku?</div>
        <div class="mt-2 text-md-regular text-gray-600 text-center">
          Ne brinite, poslaćemo vam uputstvo za resetovanje lozinke.
        </div>

        <app-field label="Email" class="mt-5 w-full">
          <app-email-input
            ctrlPlaceholder="Unesite email adresu"
            [formCtrl]="form.controls['email'] | formControl"
            (onEnterClicked)="submit()"
          ></app-email-input>
        </app-field>

        <app-button class="mt-4 w-full" (btnClicked)="submit()" [btnSize]="ButtonSize.MD">
          <div class="text-sm-semibold text-white">Pošalji</div>
        </app-button>

        <div class="mt-4 flex align-items-center justify-content-center text-sm-semibold text-gray-700 cursor-pointer"
             (click)="location.routeToLogin()">
          Nazad na prijavu
        </div>
      } @else {
        <div class="icon-badge">
          <app-mail-01 stroke="#414651" width="1.5rem" height="1.5rem"></app-mail-01>
        </div>
        <div class="mt-3 display-sm-semibold text-gray-900 text-center">Proverite svoj email</div>
        <div class="mt-2 text-md-regular text-gray-700 text-center email-sent-text">
          Poslali smo link za resetovanje lozinke na<br />{{ form.value.email }}
        </div>

        <div class="mt-5 flex align-items-center justify-content-center gap-1">
          <div class="text-sm-regular text-gray-600">Niste dobili email?</div>
          <div class="text-sm-semibold text-gray-900 cursor-pointer" (click)="resend()">Pošaljite ponovo</div>
        </div>

        <div class="mt-4 flex align-items-center justify-content-center text-sm-semibold text-gray-700 cursor-pointer"
             (click)="location.routeToLogin()">
          Nazad na prijavu
        </div>
      }
    </div>
  </div>

  <div class="flex justify-content-center text-sm-regular text-gray-600 p-4 md:p-5 text-center">
    © Full Scale Solutions {{ currentYear }}
  </div>
</div>
